import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Link, withRouter } from 'react-router-dom';
import OTextField from 'components/commons/OTextField';
import User from 'core/User';
import * as Messages from 'constants/Messages';
import { Card, Button, Spin, Affix, Form, Icon, Input, Checkbox, notification } from 'antd';
import { Redirect } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import { translate } from 'react-i18next';
import cookie from 'react-cookies'

const FormItem = Form.Item;

class NormalLoginForm extends React.Component {
	constructor(props) {
		super(props);
		this.crudService = props.crudService;
		this.state = { loading: false, login: { username: '', password: '' } };
	}

	handleSubmit(e) {
		e.preventDefault();
		this.props.form.validateFields(async (err, values) => {
			if (!err) {
				console.log('Received values of form: ', values);

				this.setState({ loading: true });
				try {
	
					const user = await this.crudService.getUser(values.userName);
					let pwdMatch = this.crudService.checkSaltHashPassword(values.password, user.password, user.salt);                                    
					
					if (user && this.props.onUpdate && values.userName === user.username && pwdMatch === true && user.active === 1) {
						this.props.onUpdate(user);
						this.crudService.updateActivity(user.id);
						 const expires = new Date()
						 expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 14)  			                

						cookie.save('djutyuser', user, { path: '/',expires})

                        this.setState({ isLogged: true });
						
					} else {
						notification.open({ message: Messages.LOGIN_FAILED, description: Messages.LOGIN_FAILED_DESC });
						e.preventDefault();
					}
				} catch (e) {
					notification.open({ message: Messages.LOGIN_FAILED, description: Messages.LOGIN_FAILED_DESC });
				}
				this.setState({ loading: false });
			}
		});
	}

	render() {
		const { t } = this.props;
		const { getFieldDecorator } = this.props.form;
		return (
			<Spin spinning={this.state.loading}>
				<h1>{t('title')}</h1>
				<Form onSubmit={this.handleSubmit.bind(this)} className="login-form">
					<FormItem>
						{getFieldDecorator('userName', {
							rules: [{ required: true, message: 'Please input your username!' }]
						})(<Input addonBefore={t('username')} size="lg" placeholder="Enter your email or your username" />)}
					</FormItem>
					<FormItem>
						{getFieldDecorator('password', {
							rules: [{ required: true, message: 'Please input your Password!' }]
						})(<Input addonBefore={t('password')} size="lg" type="password" placeholder="Enter your password" />)}
					</FormItem>
					<FormItem>
						<Button type="primary" htmlType="submit" size="lg" className="login-form-button">
							LOGIN
						</Button>
						<p style={{ textAlign: 'center' }}>
							Or <Link to={`http://djuty.com/register/`}>{t('register')}</Link>
						</p>
					</FormItem>
				</Form>
			</Spin>
		);
	}
}

export default translate('translations')(Form.create()(NormalLoginForm));



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js